module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "appendToBody": true,
      "placeInTop": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "sds-schedule text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "sds-schedule__header"
  }, [_c('h2', [_vm._v("Skemalæg brikker")]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle sds-schedule__header__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sds-schedule__content"
  }, [_c('p', {
    staticClass: "sds-schedule__period"
  }, [_vm._v(_vm._s(_vm.periodLabel))]), _vm._v(" "), (_vm.rows.length > 1) ? _c('div', {
    staticClass: "sds-schedule__common"
  }, [_c('span', {
    staticClass: "sds-schedule__common__label"
  }, [_vm._v("Samme tid for alle:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commonStart),
      expression: "commonStart"
    }],
    staticClass: "sds-schedule__input sds-schedule__input--common",
    attrs: {
      "type": "time"
    },
    domProps: {
      "value": (_vm.commonStart)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commonStart = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sds-schedule__common__sep"
  }, [_vm._v("–")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commonEnd),
      expression: "commonEnd"
    }],
    staticClass: "sds-schedule__input sds-schedule__input--common",
    attrs: {
      "type": "time"
    },
    domProps: {
      "value": (_vm.commonEnd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commonEnd = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.rows.length === 0) ? _c('p', {
    staticClass: "sds-schedule__empty"
  }, [_vm._v("Der er ingen brikker at skemalægge.")]) : _c('table', {
    staticClass: "do-table do-table--striped sds-schedule__table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "sds-schedule__cell-name"
  }, [_vm._v("Brik")]), _vm._v(" "), _c('th', {
    staticClass: "sds-schedule__cell-classes"
  }, [_vm._v("Klasser")]), _vm._v(" "), _c('th', {
    staticClass: "sds-schedule__cell-time"
  }, [_vm._v("Fra")]), _vm._v(" "), _c('th', {
    staticClass: "sds-schedule__cell-time"
  }, [_vm._v("Til")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.rows), function(row) {
    return _c('tr', {
      key: row.subject.id,
      class: {
        'sds-schedule__row--error': row.error
      }
    }, [_c('td', {
      staticClass: "sds-schedule__cell-name"
    }, [_c('span', {
      staticClass: "sds-schedule__pill",
      style: ({
        backgroundColor: row.subject.color
      })
    }, [_vm._v(_vm._s(row.subject.name))])]), _vm._v(" "), _c('td', {
      staticClass: "sds-schedule__cell-classes"
    }, [_vm._v(_vm._s(_vm.classNames(row.subject) || '–'))]), _vm._v(" "), _c('td', {
      staticClass: "sds-schedule__cell-time"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.start),
        expression: "row.start"
      }],
      staticClass: "sds-schedule__input",
      attrs: {
        "type": "time"
      },
      domProps: {
        "value": (row.start)
      },
      on: {
        "change": function($event) {
          row.error = false
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "start", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "sds-schedule__cell-time"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.end),
        expression: "row.end"
      }],
      staticClass: "sds-schedule__input",
      attrs: {
        "type": "time"
      },
      domProps: {
        "value": (row.end)
      },
      on: {
        "change": function($event) {
          row.error = false
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "end", $event.target.value)
        }
      }
    })])])
  }), 0)]), _vm._v(" "), (_vm.timeError) ? _c('p', {
    staticClass: "sds-schedule__error"
  }, [_vm._v("Sluttid skal være efter starttid for alle brikker.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "sds-schedule__footer"
  }, [_c('button', {
    staticClass: "do-bttn",
    attrs: {
      "disabled": _vm.isScheduling
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Annuller")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--loading': _vm.isScheduling
    },
    attrs: {
      "disabled": _vm.isScheduling || _vm.rows.length === 0
    },
    on: {
      "click": _vm.runSchedule
    }
  }, [_vm._v("Skemalæg")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-25869126!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SpecialDays/SpecialDayScheduleModal.vue
// module id = 1811
// module chunks = 1